export const BILLING_IDS = {
    COMMERCE: 'commerce',
    SEARCH_ANALYTICS: 'search_analytics',
    DISCOVER_ANALYTICS: 'discover_analytics',
    AI_TRACKING: 'ai_tracking',
    ADDITIONAL_SEATS: 'additional_seats',
    CONTENT_ANALYSIS: 'additional_content_analysis',
};
